var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"section-title"},[_c('base-section-title',{attrs:{"title":"内容变更"}})],1),_c('div',{staticClass:"section-content"},[_c('jczh-descriptions',{attrs:{"info":_vm.changeInfo.changeInfo || {},"option":_vm.contentOptions,"el-attrs":{
            size: 'medium',
            column: 1,
            labelStyle: {
              width: '140px',
              whiteSpace: 'nowrap',
              textAlign: 'right'
            }
          }},scopedSlots:_vm._u([{key:"competitionStart",fn:function(ref){
          var value = ref.value;
return [_c('span',[_vm._v(_vm._s(value ? _vm.strToThousands(value) : '-')+" 元")]),_c('money-in-cn',{attrs:{"money":value}})]}},{key:"offerRange",fn:function(ref){
          var value = ref.value;
return [_c('span',[_vm._v(_vm._s(value ? _vm.strToThousands(value) : '-')+" 元")]),_c('money-in-cn',{attrs:{"money":value}})]}}])})],1)]),_c('div',{staticClass:"section"},[_c('div',{staticClass:"section-title"},[_c('base-section-title',{attrs:{"title":"变更公告"}})],1),_c('div',{staticClass:"section-content"},[_c('jczh-descriptions',{attrs:{"info":_vm.changeInfo.notice || {},"option":_vm.noticeOptions,"el-attrs":{
            size: 'medium',
            column: 1,
            labelStyle: {
              width: '140px',
              whiteSpace: 'nowrap',
              textAlign: 'right'
            }
          }},scopedSlots:_vm._u([{key:"noticeContent",fn:function(){return [_c('u-editor',{attrs:{"disabled":"","value":_vm.content}})]},proxy:true}])})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }